import { Component, AfterViewInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';

import { Subscription } from 'rxjs';

import { ErrorModalService } from '@app/shared/modals/error-modal/error-modal.service';
import { ErrorWrapper } from '@interfaces/error-wrapper.interface';

import '@wdpr/button';
import '@wdpr/modal';

@Component({
  standalone: false,
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss']
})
export class ErrorModalComponent implements AfterViewInit, OnDestroy {

  @ViewChild('errorModal', {static: false}) errorModal: ElementRef;
  errorWrapper = null;
  stream$: Subscription;

  constructor(private errorModalService: ErrorModalService) {}

  ngAfterViewInit() {
    this.stream$ = this.errorModalService.getErrorStream()
      .subscribe((errorWrapper: ErrorWrapper) => {
        if (errorWrapper?.statusCode === '404') {
          return;
        }

        this.toggle(errorWrapper);
      });
  }

  ngOnDestroy() {
    this.stream$.unsubscribe();
  }

  toggle(errorWrapper: ErrorWrapper) {
    this.errorWrapper = errorWrapper;
    this.errorModal.nativeElement.open = !!errorWrapper;
  }

  _closeOnBackground(_event: any) {
    // noop - placeholder for background close handler
  }

}
